module.exports = __webpack_public_path__ + "static/media/earth.e9348ddd.jpg";